import { Skeleton } from '@/core/ui/atoms/skeleton'

export const InfinitePostsSkeleton = () => {
  return (
    <div className='flex flex-wrap gap-5'>
      {Array.from({ length: 5 }).map((_, i) => (
        <div className='flex flex-col gap-2' key={i}>
          <Skeleton width={200} height={200} />
          <Skeleton width={75} height={20} />
          <Skeleton width={100} height={15} />
        </div>
      ))}
    </div>
  )
}
